import { useEffect, useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { Toast } from "primereact/toast";
import { GenerateInvice } from "./GenerateInvice";
import { SVInvoicesToUpdatePaymentStatus } from "./SVInvoicesToUpdatePaymentStatus";

interface IProps {
    byPrimeInvoice?: { singleData: any, open: boolean },
    isProcess: boolean;
}

export const SubVendorInvoices = (props: IProps) => {
    const [modal, setModal] = useState({ singleData: {}, recent: {}, open: false } as { singleData: any, recent: any, open: boolean });
    const [reload, setReload] = useState<boolean>(false);
    const [showGenerateInvice, setShowGenerateInvice] = useState<boolean>(false);
    const toast = useRef<any>(null);

    const onHideModal = () => {
        setModal({ singleData: {}, recent: {}, open: false });
    };
    const onOpenModal = (data: any) => {
        if (props.byPrimeInvoice?.open) {
            setModal({ singleData: props.byPrimeInvoice.singleData, recent: {}, open: true });
        } else {
            setModal({ singleData: data, recent: {}, open: true });
        }
    };

    useEffect(() => {
        if (props.byPrimeInvoice?.open) {
            setModal({ singleData: props.byPrimeInvoice.singleData, recent: {}, open: false });
        }
    }, []);

    return (
        <>
            {/* {showGenerateInvice && props.byPrimeInvoice?.singleData?.primevendorInvoice_ID && <GenerateInvice singleData={props.byPrimeInvoice?.singleData} toast={toast} setReload={setReload} reload={reload} />} */}
            {!props.byPrimeInvoice?.singleData?.primevendorInvoice_ID && <Form open={modal.open} singleData={modal.singleData} recent={modal.recent} onHide={onHideModal} toast={toast} />}
            {props.isProcess === false && <Table openForm={onOpenModal} toast={toast} open={modal.open} setModal={setModal} byPrimeInvoice={props.byPrimeInvoice} reload={reload} setShowGenerateInvice={setShowGenerateInvice} />}
            {props.isProcess === true && <SVInvoicesToUpdatePaymentStatus setModal={setModal} toast={toast} />}
            <Toast ref={toast} />
        </>
    );
}